import type { StateCreator } from "zustand";
import type { ResolutionLabel } from "./pick-resolution";

export interface PanelResolutionSlice {
    panelResolutions: Record<string, ResolutionLabel>;
    setPanelResolution: (panelId: string, resolution: ResolutionLabel) => void;
}

export const createPanelResolutionSlice: StateCreator<PanelResolutionSlice, [], [], PanelResolutionSlice> = (set) => ({
    panelResolutions: {},
    setPanelResolution: (panelId, resolution) =>
        set((state) => ({
            panelResolutions: { ...state.panelResolutions, [panelId]: resolution },
        })),
});
